
      const runtimeConfigPath = "/config.js";
      await import(/* @vite-ignore */ runtimeConfigPath);
      await import("/src/main.jsx");
    